import { EventName, EventPayloads, QuoteChange } from "./events";
import { track } from "./index";

/** El precio que ve el cliente en la pantalla de precio. */
export type QuoteShown = EventPayloads["quote_viewed"];

/**
 * Qué cambió de un precio a otro: el capital, la cobertura o la periodicidad
 * (en ese orden si cambian varias) u `other` si solo cambió el precio (p. ej.
 * al activar o quitar una garantía).
 */
export const quoteChangeOf = (previous: QuoteShown, next: QuoteShown): QuoteChange => {
  if (previous.capital !== next.capital) return "capital";
  if (previous.coverage !== next.coverage) return "coverage";
  if (previous.period !== next.period) return "period";
  return "other";
};

type Emit = <K extends EventName>(name: K, payload: EventPayloads[K]) => void;

/**
 * Una entrada en el paso de precio (se crea al montar la pantalla): el primer
 * precio es `quote_viewed`; cada precio distinto después, `quote_changed` con
 * el campo que cambió. El mismo precio otra vez no emite nada.
 */
export const createQuoteTracker = (emit: Emit = track): ((quote: QuoteShown) => void) => {
  let previous: QuoteShown | null = null;
  let previousSignature: string | null = null;
  return (quote) => {
    const signature = JSON.stringify([quote.capital, quote.price, quote.period, quote.coverage]);
    if (signature === previousSignature) return;
    if (previous === null) {
      emit("quote_viewed", quote);
    } else {
      emit("quote_changed", { changed: quoteChangeOf(previous, quote), ...quote });
    }
    previous = quote;
    previousSignature = signature;
  };
};
